import { NotificationInterface } from './notification';

export interface DmNotificationsInterface {
  unreadNotifications: NotificationInterface[];
  readNotifications: NotificationInterface[];
}
